import { ProjectContribution } from './project-contribution';
import { ProjectLeader } from './project-leader';
import { DeveloperContribution } from './developer-contribution';

export interface MemberCollaboration {
  projectContributions: ProjectContribution[];
  projectLeadership: ProjectLeader[];
  developerContributions: DeveloperContribution[];
}
